export default __webpack_public_path__ + "static/upcomingimg4-aaa8de4c0cc5fae8efacc7c80f7b6860.png";